import {
  DropdownMenuCaret,
  DropdownTriggerButton,
  DropdownWrapper,
} from '@findy-code/yuffie/shared/dropdown-menu';
import { useCallback, useEffect, useState } from 'react';

import { DropdownMenu } from './dropdown-menu.component';
import { ToggleMenuList } from './toggle-menu-list.component';
import styles from './user-name-dropdown-menu.component.module.scss';

type Props = {
  userName: string;
  profileCompletionProgress?: number;
  hideSettingsMenu?: boolean;
  hideProfileMenu?: boolean;
  onLogout: () => void;
};

export const UserNameDropdownMenu = ({
  userName,
  profileCompletionProgress,
  hideSettingsMenu,
  hideProfileMenu,
  onLogout,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onRequestClose = useCallback((e: MouseEvent) => {
    if (!(e.target instanceof HTMLElement)) {
      return;
    }
    // NOTE:
    // ドロップダウンメニューボタン自体のクリックイベントはReactで処理するため、それ以外のクリック時にドロップダウンメニューを閉じる
    if (!e.target.closest('#user-name-dropdown-trigger-button')) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    // NOTE:
    // メインコンテンツ・ヘッダーコンテンツのクリック時にドロップダウンメニューを閉じる
    const mainEl = document.querySelector('main');
    const headerEl = document.querySelector('header');

    if (isOpen && mainEl) {
      mainEl.addEventListener('click', onRequestClose);
    }
    if (isOpen && headerEl) {
      headerEl.addEventListener('click', onRequestClose);
    }

    return () => {
      if (mainEl) {
        mainEl.removeEventListener('click', onRequestClose);
      }
      if (headerEl) {
        headerEl.removeEventListener('click', onRequestClose);
      }
    };
  }, [isOpen, onRequestClose]);

  return (
    <div>
      <DropdownTriggerButton
        id="user-name-dropdown-trigger-button"
        type="button"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        <span className={styles.userName}>{userName}</span>
        <DropdownMenuCaret />
      </DropdownTriggerButton>
      <DropdownWrapper className={isOpen ? 'open' : undefined}>
        <DropdownMenu>
          <ToggleMenuList
            hideProfileMenu={hideProfileMenu}
            hideSettingsMenu={hideSettingsMenu}
            profileCompletionProgress={profileCompletionProgress}
            onClickLogoutButton={onLogout}
          />
        </DropdownMenu>
      </DropdownWrapper>
    </div>
  );
};
